import React from 'react'

export const FollowButton = ({id, button=false}) =>{
    const [active] = React.useState(button)

    return (<div className={`button ${active ? 'following':''}`}>
        <p className={`${active ? '':'outline'}`} >
            {active ? 'Following' : 'Follow'}
        </p>
    </div>)
}
 
